<template>
   <div class="icon">
    <img :src="url"  style="width:30px"/>
   </div>
</template>

<script>
export default {
  name : 'Icon',
  props: {
    url:String
  }
}
</script>

<style scoped>
  .icon:hover {
    cursor: pointer;
    opacity: 1;
  }
  .icon {
    margin-right: 25px;
    opacity: .6;
  }
</style>




// WEBPACK FOOTER //
// src/components/Layout/Icon.vue